
export default function Products() {
  const products = [
    {
      name: 'Bearings',
      icon: 'ri-settings-3-line',
      description: 'High-precision ball bearings, roller bearings, and specialty bearings for all industrial applications'
    },
    {
      name: 'Chains',
      icon: 'ri-links-line',
      description: 'Industrial chains, conveyor chains, and transmission chains for heavy-duty operations'
    },
    {
      name: 'Couplings',
      icon: 'ri-git-merge-line',
      description: 'Flexible and rigid couplings for power transmission and mechanical connections'
    },
    {
      name: 'Oil Seals',
      icon: 'ri-shield-check-line',
      description: 'Premium quality seals and gaskets for leak prevention and equipment protection'
    },
    {
      name: 'Lubricants',
      icon: 'ri-drop-line',
      description: 'Industrial lubricants, greases, and oils for optimal equipment performance'
    },
    {
      name: 'Power Transmission',
      icon: 'ri-flashlight-line',
      description: 'Belts, pulleys, and power transmission components for industrial machinery'
    },
    {
      name: 'Hydraulic Components',
      icon: 'ri-water-percent-line',
      description: 'Hydraulic pumps, valves, and fittings for fluid power systems'
    },
    {
      name: 'MRO Supplies',
      icon: 'ri-tools-line',
      description: 'Maintenance, repair, and operations supplies for industrial facilities'
    }
  ];

  return (
    <section id="products" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Our <span className="text-blue-600">Products</span>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive range of industrial components and supplies to meet all your operational needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-product-shop>
          {products.map((product, index) => (
            <div
              key={index}
              className="group bg-gray-50 hover:bg-blue-50 p-8 rounded-xl transition-all duration-300 hover:shadow-lg hover:transform hover:scale-105 cursor-pointer"
            >
              <div className="w-16 h-16 bg-blue-100 group-hover:bg-blue-200 rounded-lg flex items-center justify-center mb-6 transition-colors">
                <i className={`${product.icon} text-2xl text-blue-600`}></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-blue-900">
                {product.name}
              </h4>
              <p className="text-gray-600 group-hover:text-gray-700 leading-relaxed">
                {product.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a href="/SUNCORE_BROCHURE.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
            <div className="w-6 h-6 inline-flex items-center justify-center mr-2">
              <i className="ri-file-list-3-line"></i>
            </div>
            View Complete Catalog
          </a>
        </div>
      </div>
    </section>
  );
}
